import styled from "styled-components/macro";

export const GridContainer = styled.div`
  width: 90%;
  margin: 0 auto;
  .ant-carousel .slick-prev,
  .ant-carousel .slick-next,
  .ant-carousel .slick-prev:hover,
  .ant-carousel .slick-next:hover {
    font-size: inherit;
    color: currentColor;
  }
  position: relative;

  @media (max-width: 1000px) {
    max-width: 800px;
  }

  @media (max-width: 768px) {
    max-width: ${(props) => props.theme.sizes.maxWidthContainer};
  }

  @media (max-width: 570px) {
    max-width: 500px;
  }

  @media (max-width: 450px) {
    max-width: 400px;
  }


  @media (max-width: 375px) {
    max-width: 350px;
  }

`;

export const Arrow = styled.div`
  position: absolute;
  z-index: 30;
  width: 20px;
  height: 20px;
  border-left: 2px solid #032565;
  border-top: 2px solid #032565;
  bottom: calc(50% - 10px);
  cursor: pointer;
  @media ${(props) => props.theme.media.phone} {
    display: none;
  }
`;
export const ArrowNext = styled(Arrow)`
  right: -25px;
  transform: rotate(135deg);
`;
export const ArrowPrev = styled(Arrow)`
  left: -25px;
  transform: rotate(-45deg);
`;
